import type { Genre, Collection, Movie } from '@/types/movie';

export const genres: Genre[] = [
  { key: 'action', name: '动作', icon: 'ri-sword-line', description: '枪战、追车与正邪对决，肾上腺素飙升的高能类型。' },
  { key: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line', description: '轻松诙谐、笑点密集，最适合放松心情的观影选择。' },
  { key: 'scifi', name: '科幻', icon: 'ri-planet-line', description: '穿梭星际与未来世界，用想象力构建震撼的宇宙图景。' },
  { key: 'romance', name: '爱情', icon: 'ri-heart-3-line', description: '细腻动人的情感叙事，关于相遇、心动与相守的故事。' },
  { key: 'thriller', name: '悬疑', icon: 'ri-eye-line', description: '层层反转与烧脑谜题，让你全程屏息、欲罢不能。' },
  { key: 'animation', name: '动画', icon: 'ri-magic-line', description: '适合全年龄段的想象力盛宴，画面与故事同样精彩。' },
  { key: 'horror', name: '恐怖', icon: 'ri-ghost-line', description: '阴森氛围与惊悚张力，胆量与心跳的双重考验。' },
  { key: 'drama', name: '剧情', icon: 'ri-film-line', description: '聚焦人性与生活，情感饱满、值得细细品味的佳作。' },
  { key: 'adventure', name: '冒险', icon: 'ri-compass-3-line', description: '踏上未知旅途，探索充满惊喜与挑战的广阔世界。' },
  { key: 'crime', name: '犯罪', icon: 'ri-spy-line', description: '罪案追踪与黑色博弈，揭示人性深处的善与恶。' },
  { key: 'fantasy', name: '奇幻', icon: 'ri-sparkling-line', description: '魔法与传说交织的异世界，现实之外的浪漫想象。' },
  { key: 'war', name: '战争', icon: 'ri-shield-line', description: '宏大战场与人性考验，还原历史洪流中的个体命运。' },
];

export const collections: Collection[] = [
  {
    key: 'hot-this-month',
    title: '本月热映',
    subtitle: '编辑精选 · 正在全网热议的口碑新片',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20festival%20marquee%20lights%20with%20warm%20orange%20glow%20rich%20color%20grading%20moody%20atmosphere%20high%20detail%20no%20text&width=800&height=500&seq=coll-hot-01&orientation=landscape',
    movieIds: ['interstellar-odyssey', 'mechanical-heart', 'fold-of-time', 'phantom-forest', 'deep-sea-beast'],
  },
  {
    key: 'top-rated',
    title: '高分佳作',
    subtitle: '口碑与评分双丰收，影迷一致力荐',
    cover: 'https://readdy.ai/api/search-image?query=golden%20award%20trophy%20on%20a%20dark%20velvet%20stage%20with%20cinematic%20spotlight%20rich%20color%20grading%20moody%20elegant%20atmosphere%20high%20detail%20no%20text&width=800&height=500&seq=coll-top-01&orientation=landscape',
    movieIds: ['interstellar-odyssey', 'mechanical-heart', 'fold-of-time', 'phantom-forest', 'last-defense-line'],
  },
  {
    key: 'mind-blowing',
    title: '悬疑烧脑',
    subtitle: '反转不断，看完还想二刷的高能悬疑',
    cover: 'https://readdy.ai/api/search-image?query=foggy%20dark%20alley%20with%20a%20single%20flickering%20street%20lamp%20cinematic%20suspense%20atmosphere%20rich%20color%20grading%20moody%20high%20detail%20no%20text&width=800&height=500&seq=coll-thriller-01&orientation=landscape',
    movieIds: ['silent-city', 'mist-lone-city', 'ghost-manor', 'interstellar-odyssey'],
  },
];

export const movies: Movie[] = [
  {
    id: 'interstellar-odyssey',
    title: '星际远征',
    enTitle: 'Star Voyage',
    year: 2024,
    genres: ['scifi', 'adventure'],
    region: '欧美',
    director: '陈墨白',
    cast: ['李维·安德森', '苏菲·罗兰', '马克·安东尼', '林婉清'],
    duration: 142,
    rating: 8.9,
    votes: '12.4万',
    synopsis: '一支人类远征队穿越虫洞，寻找新的家园，却在宇宙尽头发现了关于时间与爱的终极答案。',
    story:
      '地球资源濒临枯竭，一支由科学家与飞行员组成的远征队奉命穿越位于土星附近的虫洞，前往遥远星系寻找可供人类迁居的星球。在漫长的星际航行中，队员们不仅要面对黑洞引力与时间膨胀的残酷考验，更要直面内心深处对家人的牵挂。当队长在异星海洋上重新建立与地球的联系时，他终于明白：真正值得跨越光年去守护的，是那份永不消逝的情感。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20a%20lone%20astronaut%20standing%20before%20a%20colossal%20glowing%20wormhole%20in%20deep%20space%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20lone%20astronaut%20standing%20before%20a%20colossal%20glowing%20wormhole%20in%20deep%20space%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-01&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20lone%20astronaut%20standing%20before%20a%20colossal%20glowing%20wormhole%20in%20deep%20space%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-01a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20an%20astronaut%20inside%20a%20spaceship%20cockpit%20overlooking%20a%20distant%20blue%20planet%20moody%20lighting%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-01b&orientation=landscape',
    ],
    tags: ['太空', '硬科幻', '催泪', 'IMAX'],
    popularity: 98,
    collections: ['hot-this-month', 'top-rated', 'mind-blowing'],
  },
  {
    id: 'silent-city',
    title: '暗夜追凶',
    enTitle: 'Silent City',
    year: 2023,
    genres: ['crime', 'thriller'],
    region: '欧美',
    director: '约翰·雷德利',
    cast: ['亚瑟·科尔', '伊莎贝尔·杨', '丹尼尔·福斯特'],
    duration: 128,
    rating: 8.6,
    votes: '9.8万',
    synopsis: '一桩连环命案将落魄警探卷入城市的黑暗深处，真相远比他想象的更加危险。',
    story:
      '资深警探雷德利因一次失败的行动被降职，却在接手一桩看似普通的失踪案时，发现它与多年前的连环命案有着惊人的联系。随着调查深入，他穿梭于雨夜的霓虹街道与灰色地带，逐渐意识到真正的凶手可能就藏在自己最信任的人之中。当最后一块拼图落下，他必须在正义与生存之间做出抉择。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20a%20detective%20in%20a%20trench%20coat%20walking%20through%20rain%20soaked%20neon%20city%20streets%20at%20night%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20detective%20in%20a%20trench%20coat%20walking%20through%20rain%20soaked%20neon%20city%20streets%20at%20night%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-02&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20detective%20in%20a%20trench%20coat%20walking%20through%20rain%20soaked%20neon%20city%20streets%20at%20night%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-02a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20evidence%20photos%20and%20notes%20scattered%20on%20a%20dim%20detective%20desk%20moody%20lamplight%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-02b&orientation=landscape',
    ],
    tags: ['犯罪', '反转', '雨夜', '烧脑'],
    popularity: 91,
    collections: ['mind-blowing'],
  },
  {
    id: 'mechanical-heart',
    title: '机械之心',
    enTitle: 'Mechanical Heart',
    year: 2025,
    genres: ['animation', 'scifi'],
    region: '日韩',
    director: '宫本遥',
    cast: ['小零（配音）', '高桥悠真（配音）', '林原真纪（配音）'],
    duration: 108,
    rating: 9.1,
    votes: '15.2万',
    synopsis: '一台被遗弃的小机器人踏上寻找发明者的旅程，只为证明自己拥有一颗真正的心。',
    story:
      '在蒸汽与齿轮构成的未来都市，编号 K-07 的小机器人被制造者遗弃在回收站。为了证明自己并非废品，它带着一张褪色的照片踏上寻找发明者的旅程。一路上，它结识了落魄的钟表匠与倔强的街头女孩，也逐渐懂得：所谓的心，并非由金属构成，而是在每一次选择善良与勇敢的瞬间里慢慢生长出来的。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20a%20young%20robot%20girl%20with%20glowing%20amber%20eyes%20inside%20a%20futuristic%20workshop%20of%20gears%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20young%20robot%20girl%20with%20glowing%20amber%20eyes%20inside%20a%20futuristic%20workshop%20of%20gears%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-03&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20young%20robot%20girl%20with%20glowing%20amber%20eyes%20inside%20a%20futuristic%20workshop%20of%20gears%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-03a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20small%20robot%20meeting%20a%20street%20girl%20in%20a%20warm%20steampunk%20market%20alley%20soft%20lighting%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-03b&orientation=landscape',
    ],
    tags: ['动画', '治愈', '成长', '催泪'],
    popularity: 96,
    collections: ['hot-this-month', 'top-rated'],
  },
  {
    id: 'mist-lone-city',
    title: '迷雾孤城',
    enTitle: 'The Fog',
    year: 2024,
    genres: ['thriller', 'horror'],
    region: '日韩',
    director: '金敏秀',
    cast: ['朴智勋', '韩素妍', '崔原熙'],
    duration: 116,
    rating: 8.3,
    votes: '7.1万',
    synopsis: '一场诡异浓雾封锁小镇，被困的居民逐渐发现，真正的恐惧来自彼此。',
    story:
      '一夜之间，浓雾将宁静的山间小镇彻底封锁，通讯中断、道路消失。几名被困在咖啡馆的陌生人逐渐发现，雾中潜藏着无法解释的现象，而每个人似乎都隐瞒着与镇上失踪案有关的秘密。随着信任崩塌，他们必须在天亮之前找出真相，否则将永远留在这座被遗忘的孤城里。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20a%20foggy%20abandoned%20town%20street%20swallowed%20by%20thick%20grey%20mist%20at%20dawn%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20foggy%20abandoned%20town%20street%20swallowed%20by%20thick%20grey%20mist%20at%20dawn%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-04&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20foggy%20abandoned%20town%20street%20swallowed%20by%20thick%20grey%20mist%20at%20dawn%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-04a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20strangers%20gathered%20inside%20a%20dim%20warm%20cafe%20window%20while%20fog%20presses%20outside%20moody%20lamplight%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-04b&orientation=landscape',
    ],
    tags: ['悬疑', '氛围', '反转', '密室'],
    popularity: 88,
    collections: ['mind-blowing'],
  },
  {
    id: 'wild-return',
    title: '荒野归途',
    enTitle: 'Wild Return',
    year: 2022,
    genres: ['adventure', 'drama'],
    region: '大陆',
    director: '周牧',
    cast: ['张远山', '何小满', '巴特尔'],
    duration: 124,
    rating: 8.0,
    votes: '5.6万',
    synopsis: '一位失去方向的旅人穿越荒漠，只为回到记忆中被风沙掩埋的故乡。',
    story:
      '在城市中迷失自我的青年，收到一封来自故乡的旧信后，决定独自穿越广阔的戈壁与荒漠。旅途中，他遇到形形色色的赶路人，也一次次与死亡擦肩而过。当他终于抵达那片熟悉又陌生的土地时，才懂得归途的意义不在于终点，而在于重新学会与自己和这片土地相处。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20a%20hiker%20crossing%20a%20vast%20golden%20desert%20dune%20under%20a%20burning%20sunset%20sky%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20hiker%20crossing%20a%20vast%20golden%20desert%20dune%20under%20a%20burning%20sunset%20sky%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-05&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20hiker%20crossing%20a%20vast%20golden%20desert%20dune%20under%20a%20burning%20sunset%20sky%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-05a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20lone%20campfire%20under%20a%20vast%20star%20filled%20desert%20sky%20at%20night%20warm%20lighting%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-05b&orientation=landscape',
    ],
    tags: ['公路', '成长', '治愈', '风光'],
    popularity: 74,
    collections: [],
  },
  {
    id: 'fold-of-time',
    title: '时间的褶皱',
    enTitle: 'The Fold of Time',
    year: 2025,
    genres: ['scifi', 'romance'],
    region: '欧美',
    director: '艾米莉亚·福特',
    cast: ['诺亚·布莱克', '克莱尔·海因', '朱利安·莫斯'],
    duration: 132,
    rating: 8.8,
    votes: '11.3万',
    synopsis: '当时间可以被折叠，两个相爱的人能否在无数条时间线里再次相遇？',
    story:
      '物理学家诺亚发明了可以短暂折叠时间的装置，却因此意外失去了挚爱。为了挽回一切，他无数次回到那个决定性的夜晚，试图改变命运的轨迹。然而每一次尝试都让时间线愈发破碎，他也逐渐明白：有些人注定会相遇，而真正的爱，是在无数种可能里依然选择彼此。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20two%20lovers%20reaching%20toward%20each%20other%20across%20a%20fractured%20glowing%20timeline%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20two%20lovers%20reaching%20toward%20each%20other%20across%20a%20fractured%20glowing%20timeline%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-06&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20two%20lovers%20reaching%20toward%20each%20other%20across%20a%20fractured%20glowing%20timeline%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-06a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20scientist%20studying%20glowing%20time%20rings%20in%20a%20dim%20laboratory%20moody%20lighting%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-06b&orientation=landscape',
    ],
    tags: ['时空', '爱情', '烧脑', '催泪'],
    popularity: 94,
    collections: ['hot-this-month', 'top-rated'],
  },
  {
    id: 'summer-confession',
    title: '盛夏告白',
    enTitle: 'Summer Confession',
    year: 2023,
    genres: ['romance', 'drama'],
    region: '大陆',
    director: '林晚',
    cast: ['陈屿', '许安然', '苏念'],
    duration: 112,
    rating: 7.9,
    votes: '6.2万',
    synopsis: '那个被海风与蝉鸣填满的夏天，藏着一段迟到多年的告白。',
    story:
      '高中毕业的那个夏天，内向的男生在海边小镇结识了开朗的女孩。两人一起看露天电影、骑单车穿过长长的海堤，却始终没有说出心底的话。多年后，当他们以另一种身份重回这座小镇，那些被夏天封存的记忆与未说出口的心意，终于有了被重新拾起的机会。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20a%20couple%20holding%20hands%20on%20a%20seaside%20boardwalk%20in%20warm%20summer%20evening%20light%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-07&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20couple%20holding%20hands%20on%20a%20seaside%20boardwalk%20in%20warm%20summer%20evening%20light%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-07&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20couple%20holding%20hands%20on%20a%20seaside%20boardwalk%20in%20warm%20summer%20evening%20light%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-07a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20two%20students%20riding%20bicycles%20along%20a%20sunny%20coastal%20road%20in%20summer%20bright%20nostalgic%20lighting%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-07b&orientation=landscape',
    ],
    tags: ['青春', '治愈', '海边', '初恋'],
    popularity: 79,
    collections: [],
  },
  {
    id: 'deep-sea-beast',
    title: '深海巨兽',
    enTitle: 'Deep Sea Beast',
    year: 2024,
    genres: ['scifi', 'action'],
    region: '欧美',
    director: '大卫·麦克',
    cast: ['瑞恩·哈特', '安娜·贝尔', '凯文·伍兹'],
    duration: 118,
    rating: 7.6,
    votes: '8.9万',
    synopsis: '深海钻探队惊动沉睡亿万年的巨兽，人类将为自己的贪婪付出代价。',
    story:
      '一支深海钻探队在海底深处发现了未知的能量源，却无意间唤醒沉睡亿万年的巨型生物。随着巨兽向海面逼近，沿海城市陷入前所未有的危机。科学家与海军必须在有限时间内联手，找出阻止灾难的方法，也重新思考人类对海洋的索取究竟该止于何处。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20a%20gigantic%20sea%20monster%20rising%20from%20dark%20ocean%20waves%20toward%20a%20small%20submarine%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20gigantic%20sea%20monster%20rising%20from%20dark%20ocean%20waves%20toward%20a%20small%20submarine%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-08&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20gigantic%20sea%20monster%20rising%20from%20dark%20ocean%20waves%20toward%20a%20small%20submarine%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-08a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20stormy%20coastal%20city%20with%20giant%20waves%20crashing%20at%20night%20moody%20dramatic%20lighting%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-08b&orientation=landscape',
    ],
    tags: ['怪兽', '灾难', '视觉特效', '紧张'],
    popularity: 90,
    collections: ['hot-this-month'],
  },
  {
    id: 'ace-undercover',
    title: '王牌卧底',
    enTitle: 'Ace Undercover',
    year: 2023,
    genres: ['action', 'crime'],
    region: '大陆',
    director: '赵锋',
    cast: ['陆沉', '姜雨', '钱峰'],
    duration: 126,
    rating: 8.2,
    votes: '9.1万',
    synopsis: '为了摧毁庞大的犯罪网络，他必须把自己变成最危险的敌人。',
    story:
      '警队王牌陆沉接受了一项几乎不可能完成的任务——以全新身份潜入跨国犯罪集团的核心。他周旋于尔虞我诈的博弈之中，既要取得信任，又要守住底线。当身份濒临暴露、战友接连牺牲，他必须在真我与伪装之间做出最后的选择。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20a%20stylish%20undercover%20agent%20in%20a%20sharp%20suit%20standing%20in%20a%20warehouse%20of%20light%20beams%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-09&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20stylish%20undercover%20agent%20in%20a%20sharp%20suit%20standing%20in%20a%20warehouse%20of%20light%20beams%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-09&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20stylish%20undercover%20agent%20in%20a%20sharp%20suit%20standing%20in%20a%20warehouse%20of%20light%20beams%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-09a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20tense%20night%20meeting%20between%20two%20men%20under%20a%20dim%20parking%20garage%20light%20moody%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-09b&orientation=landscape',
    ],
    tags: ['卧底', '动作', '博弈', '硬核'],
    popularity: 85,
    collections: [],
  },
  {
    id: 'phantom-forest',
    title: '幻夜之森',
    enTitle: 'Phantom Forest',
    year: 2025,
    genres: ['fantasy', 'adventure'],
    region: '日韩',
    director: '佐藤悠',
    cast: ['宫崎凛', '新垣翔', '石川杏'],
    duration: 120,
    rating: 8.5,
    votes: '10.4万',
    synopsis: '少女误入只在月夜浮现的魔法森林，一场关于记忆与勇气的奇幻冒险就此展开。',
    story:
      '每逢月圆之夜，城市边缘的森林便会浮现出另一个世界。少女凛为了寻找失踪的哥哥，鼓起勇气踏入这片只在幻夜出现的森林。在能说话的灯笼精灵与孤傲的守林人陪伴下，她穿越重重幻境，最终发现拯救彼此的钥匙，竟是自己早已遗忘的那段记忆。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20a%20magical%20glowing%20forest%20at%20night%20with%20floating%20lanterns%20and%20a%20lone%20traveler%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20magical%20glowing%20forest%20at%20night%20with%20floating%20lanterns%20and%20a%20lone%20traveler%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-10&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20magical%20glowing%20forest%20at%20night%20with%20floating%20lanterns%20and%20a%20lone%20traveler%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-10a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20girl%20and%20a%20glowing%20lantern%20spirit%20crossing%20a%20magical%20wooden%20bridge%20soft%20enchanted%20lighting%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-10b&orientation=landscape',
    ],
    tags: ['奇幻', '冒险', '治愈', '视觉系'],
    popularity: 92,
    collections: ['hot-this-month', 'top-rated'],
  },
  {
    id: 'last-defense-line',
    title: '最后的防线',
    enTitle: 'The Last Line',
    year: 2022,
    genres: ['war', 'action'],
    region: '欧美',
    director: '迈克尔·科尔曼',
    cast: ['托马斯·格雷', '艾娃·琼斯', '卢卡斯·布朗'],
    duration: 138,
    rating: 8.4,
    votes: '8.3万',
    synopsis: '在撤退的最后关头，一支小队选择留下，只为守住希望的通道。',
    story:
      '战争进入最惨烈的阶段，大部队奉命撤退，一支残破的小队却被要求坚守断后。面对数倍于己的敌人和所剩无几的弹药，他们在废墟般的城市里筑起最后一道防线。当黎明的第一缕光照进断壁残垣，他们守护的不只是一条通道，更是所有人重新出发的可能。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20soldiers%20defending%20a%20ruined%20barricade%20city%20street%20amid%20smoke%20and%20embers%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-11&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20soldiers%20defending%20a%20ruined%20barricade%20city%20street%20amid%20smoke%20and%20embers%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-11&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20soldiers%20defending%20a%20ruined%20barricade%20city%20street%20amid%20smoke%20and%20embers%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-11a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20worn%20soldier%20at%20dawn%20looking%20over%20a%20silent%20battlefield%20somber%20lighting%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-11b&orientation=landscape',
    ],
    tags: ['战争', '群像', '热血', '催泪'],
    popularity: 81,
    collections: ['top-rated'],
  },
  {
    id: 'beneath-the-stars',
    title: '星辰下的约定',
    enTitle: 'Beneath the Stars',
    year: 2024,
    genres: ['romance', 'drama'],
    region: '日韩',
    director: '田中圭介',
    cast: ['山下遥', '松本真理', '井上树'],
    duration: 106,
    rating: 8.1,
    votes: '5.9万',
    synopsis: '两个追星星的年轻人许下约定，多年后他们是否还记得那片夜空？',
    story:
      '大学天文社的两个人因一场流星雨相识，约定要在十年后回到同一座山顶看星星。毕业后，现实的洪流将他们推向不同的城市与人生。当约定的日子临近，他们各自站在人生的十字路口，开始重新审视那个关于星空的承诺，以及藏在心底从未说出口的话。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20a%20young%20couple%20sitting%20on%20a%20rooftop%20under%20a%20vast%20starlit%20night%20sky%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-12&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20young%20couple%20sitting%20on%20a%20rooftop%20under%20a%20vast%20starlit%20night%20sky%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-12&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20young%20couple%20sitting%20on%20a%20rooftop%20under%20a%20vast%20starlit%20night%20sky%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-12a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20telescope%20pointing%20at%20a%20meteor%20shower%20over%20a%20mountain%20observatory%20soft%20night%20lighting%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-12b&orientation=landscape',
    ],
    tags: ['爱情', '青春', '治愈', '文艺'],
    popularity: 76,
    collections: [],
  },
  {
    id: 'roaring-era',
    title: '狂飙时代',
    enTitle: 'Roaring Era',
    year: 2023,
    genres: ['comedy', 'drama'],
    region: '大陆',
    director: '孙鹏',
    cast: ['王大锤', '李娜', '赵小北'],
    duration: 104,
    rating: 7.7,
    votes: '7.4万',
    synopsis: '一支濒临解散的草根乐队，用一个夏天赌上全部，只为唱给世界听。',
    story:
      '车库乐队“狂飙”即将因为现实压力解散，主唱却意外获得一次参加城市音乐节的资格。为了抓住最后的机会，这几个格格不入的年轻人必须在最短时间里筹到报名费、写出压轴曲，还要应付一群看笑话的对手。荒诞又热血的追逐中，他们找回了最初玩音乐的快乐。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20a%20fun%20retro%20garage%20band%20performing%20on%20a%20vibrant%20stage%20with%20bold%20colorful%20lighting%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-13&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20fun%20retro%20garage%20band%20performing%20on%20a%20vibrant%20stage%20with%20bold%20colorful%20lighting%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-13&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20fun%20retro%20garage%20band%20performing%20on%20a%20vibrant%20stage%20with%20bold%20colorful%20lighting%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-13a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20friends%20rehearsing%20in%20a%20cluttered%20sunlit%20garage%20with%20instruments%20warm%20nostalgic%20lighting%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-13b&orientation=landscape',
    ],
    tags: ['喜剧', '音乐', '热血', '青春'],
    popularity: 72,
    collections: [],
  },
  {
    id: 'ghost-manor',
    title: '幽灵古堡',
    enTitle: 'Ghost Manor',
    year: 2024,
    genres: ['horror', 'thriller'],
    region: '欧美',
    director: '伊桑·克莱恩',
    cast: ['奥利维亚·格雷', '杰克·沃德', '米娅·洛佩兹'],
    duration: 110,
    rating: 7.4,
    votes: '6.7万',
    synopsis: '一群年轻人闯入传说中的古堡过夜，却发现离开的门早已悄然关上。',
    story:
      '为了拍摄一部惊悚短片，几名年轻人来到传说中闹鬼的悬崖古堡。起初一切都像恶作剧，直到他们发现古堡里每一本日记、每一面镜子都指向同一个名字。午夜降临，走廊的烛光依次熄灭，他们必须在黎明前解开古堡的诅咒，否则所有人都将成为它新的“住客”。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20key%20art%20of%20a%20dark%20gothic%20castle%20on%20a%20cliff%20with%20a%20single%20glowing%20window%20in%20the%20fog%20dramatic%20cinematic%20lighting%20rich%20color%20grading%20subtle%20film%20grain%20moody%20dark%20background%20no%20text%20professional%20key%20art%20high%20detail&width=600&height=900&seq=mv-poster-14&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20dark%20gothic%20castle%20on%20a%20cliff%20with%20a%20single%20glowing%20window%20in%20the%20fog%20epic%20dramatic%20lighting%20rich%20color%20grading%20cinematic%20composition%20moody%20atmosphere%20high%20detail%20no%20text&width=1600&height=900&seq=mv-backdrop-14&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20dark%20gothic%20castle%20on%20a%20cliff%20with%20a%20single%20glowing%20window%20in%20the%20fog%20natural%20dramatic%20lighting%20film%20color%20grading%20wide%20shot%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-14a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=cinematic%20film%20scene%20of%20a%20dim%20candlelit%20castle%20corridor%20with%20flickering%20shadows%20creepy%20moody%20lighting%20film%20color%20grading%20high%20detail%20no%20text&width=1200&height=675&seq=mv-shot-14b&orientation=landscape',
    ],
    tags: ['恐怖', '惊悚', '氛围', '密室'],
    popularity: 69,
    collections: ['mind-blowing'],
  },
];